<script setup lang="ts">
import { useSettings } from "~/store/settings";
import { sitemapMatcher } from "~/utils/sitemaps/sitemapMatcher";

const settings = useSettings();
const route = useRoute();
const meta = computed(() => {
	try {
		const routeFilterOptions = calculateSitemapPath();
		const defaultMeta = sitemapMatcher({ sitemap: settings.getSitemap, routeFilterOptions: { A: "Home" } });

		let filteredData;
		try {
			filteredData = sitemapMatcher({ sitemap: settings.getSitemap, routeFilterOptions });

			if (!filteredData?.PT) filteredData = defaultMeta;
		} catch (e) {
			filteredData = defaultMeta;
		}

		return {
			title: filteredData?.PT,
			description: filteredData?.PD,
		};
	} catch (e) {
		return {
			title: "Betway",
			description: "",
		};
	}
});

const canonicalUrl = computed(() => {
	if (process.server) return;
	return window.location.origin + route.path;
});

const isClient = computed(() => process.client);
const robotsContent = computed(() => {
	if (process.client) {
		return window.location.origin.includes("synapse") ? "noindex, nofollow" : "all";
	}
});

const twitterHandle = computed(() => {
	return settings.config?.devConfig.twitterHandle;
});
</script>

<template>
	<Head>
		<Title>{{ meta.title ?? "Betway" }}</Title>
		<Meta name="description" :content="meta.description ?? ''" />
		<Meta v-if="isClient" name="robots" :content="robotsContent" />
		<Link v-if="canonicalUrl" rel="canonical" :href="canonicalUrl" />
		<meta property="og:title" :content="meta.title ?? 'Betway'" />
		<meta property="og:type" content="website" />
		<meta v-if="canonicalUrl" property="og:url" :content="canonicalUrl" />
		<meta property="og:image" content="/betway.png" />
		<meta name="twitter:card" content="summary_large_image" />
		<meta v-if="twitterHandle" name="twitter:site" :content="twitterHandle" />
		<meta name="twitter:title" :content="meta.title ?? 'Betway'" />
		<meta name="twitter:description" :content="meta.description ?? ''" />
		<meta name="twitter:image" content="/betway-og.png" />
	</Head>
</template>
